
import { useAuth } from '../context/AuthContext';
import { useWedding } from '../context/WeddingContext';
import { getTranslation } from '../i18n';
import { Locale } from '../types';

export const useTranslation = () => {
  const { user } = useAuth();
  const { activeWedding } = useWedding();

  // Resolution order: User pref > Wedding default > English
  const locale: Locale = user?.language || activeWedding?.defaultLanguage || 'en';

  const t = (path: string) => getTranslation(locale, path);

  return { t, locale };
};
